module.exports = __webpack_public_path__ + "static/img/loading-0.a72011cc.gif";